import useSwr from "@/core/composables/swr/useSwr";
import {contestApi} from "@/container";
import useExperimentalFeatures from "@/core/composables/experimental-features/useExperimentalFeatures";
import {computed, Ref} from "vue";
import {cacheKey} from "@/lib/cache";

const useGroupingContests = (status: Ref<'ended' | 'upcoming' | null>) => {
    const {enabled} = useExperimentalFeatures();

    const swrKey = computed(() => {
        const params = {status: status.value};

        if (enabled.value) {
            params['experimental'] = true;
        }

        return cacheKey('grouping/contests', params);
    });

    return useSwr(
        () => swrKey.value,
        () => contestApi().groupingContests({
            status: status.value,
            ...enabled.value ? {experimental: true} : {}
        })
    );
};

export default useGroupingContests;
